import api from 'api/axios';
import { QAItem } from 'types/api.d';
const workspaceModuleApi = {
  getQaList: async (page: number, perPage: number = 10) => {
    try {
      const response = await api.get(
        `workspace/qa?page=${page}&per_page=${perPage}`
      );
      return response.data as {
        total: number;
        next: string;
        previous: string;
        results: QAItem[];
      };
    } catch (error) {
      throw error;
    }
  },

  addQaDocument: async (
    link: string,
    categoryId?: number,
    departmentId?: number
  ) => {
    try {
      const response = await api.post('workspace/qa/from_document/', {
        link,
        category: categoryId,
        department: departmentId,
      });
      return response.data as QAItem;
    } catch (error) {
      throw error;
    }
  },
  addQaItem: async (data: {
    question: string;
    answer: string;
    category: number;
    department: number;
  }) => {
    try {
      const response = await api.post('workspace/qa/', data);
      return response.data as QAItem;
    } catch (error) {
      throw error;
    }
  },
  deleteQaItem: async (id: number) => {
    try {
      await api.delete(`workspace/qa/${id}/`);
    } catch (error) {
      throw error;
    }
  },

  putQaItem: async (id: number, data: {}) => {
    try {
      const response = await api.put(`workspace/qa/${id}/`, data);
      return response.data as QAItem;
    } catch (error) {
      throw error;
    }
  },
};
export { workspaceModuleApi };
